export function isInputActive() {
    return document.activeElement instanceof HTMLInputElement || document.activeElement instanceof HTMLTextAreaElement;
}
